import React, { Component } from 'react';
import { Image } from 'pixboost-react';
import pixboostConfig from '../../../config/pixboost';
import './PageTitle.css';

class PageTitle extends Component {
  render() {
    if (!this.props.contentBlock || !this.props.storeConfig) {
      return null;
    }

    const {
      title,
      description,
      image,
      backgroundColour,
      titleFontSize
    } = this.props.contentBlock;
    const { imageBasePath } = this.props.storeConfig;

    return (
      <div
        className={`page-title ${backgroundColour ? backgroundColour : ''} ${
          image ? 'has-image' : ''
        }`}
      >
        <div className="text">
          {title && (
            <div className={`title ${titleFontSize ? titleFontSize : ''}`}>
              {title}
            </div>
          )}
          {description && (
            <div className="description">
              {description && <p>{description}</p>}
              {image && (
                <div className="image">
                  <Image
                    src={imageBasePath + image}
                    alt={title}
                    config={pixboostConfig}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/content-blocks/PageTitle/PageTitle.js